export interface TvShow {
  id: number;
  title: string;
  englishTitle: string;
  category: string;
  genre: string[];
  region: string;
  year: number;
  episodeCount: number;
  currentEpisode: number;
  status: '更新中' | '已完结';
  rating: number;
  description: string;
  coverImage: string;
  bannerImage: string;
  director: string;
  cast: string[];
  updateDay: string;
  views: number;
  isHot: boolean;
  isNew: boolean;
}

export interface TvCategory {
  slug: string;
  name: string;
  icon: string;
}

export interface TvArticle {
  id: number;
  title: string;
  category: string;
  summary: string;
  content: string;
  author: string;
  publishDate: string;
  coverImage: string;
  views: number;
  tags: string[];
}

export const categories: TvCategory[] = [
  { slug: 'all', name: '全部', icon: 'ri-movie-line' },
  { slug: 'drama', name: '电视剧', icon: 'ri-tv-line' },
  { slug: 'movie', name: '电影', icon: 'ri-film-line' },
  { slug: 'anime', name: '动漫', icon: 'ri-ghost-line' },
  { slug: 'variety', name: '综艺', icon: 'ri-mic-line' },
];

export const genreFilters: TvCategory[] = [
  { slug: 'all', name: '全部类型', icon: 'ri-apps-line' },
  { slug: 'romance', name: '爱情', icon: 'ri-heart-line' },
  { slug: 'action', name: '动作', icon: 'ri-fire-line' },
  { slug: 'comedy', name: '喜剧', icon: 'ri-emotion-laugh-line' },
  { slug: 'suspense', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'costume', name: '古装', icon: 'ri-vip-crown-line' },
  { slug: 'urban', name: '都市', icon: 'ri-building-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
];

export const regionFilters: TvCategory[] = [
  { slug: 'all', name: '全部地区', icon: 'ri-global-line' },
  { slug: 'mainland', name: '中国大陆', icon: 'ri-flag-line' },
  { slug: 'hk-tw', name: '港台', icon: 'ri-building-2-line' },
  { slug: 'korea', name: '韩国', icon: 'ri-earth-line' },
  { slug: 'japan', name: '日本', icon: 'ri-earth-line' },
  { slug: 'western', name: '欧美', icon: 'ri-earth-line' },
];

export const yearFilters: TvCategory[] = [
  { slug: 'all', name: '全部年代', icon: 'ri-calendar-line' },
  { slug: '2026', name: '2026', icon: 'ri-calendar-2-line' },
  { slug: '2025', name: '2025', icon: 'ri-calendar-2-line' },
  { slug: '2024', name: '2024', icon: 'ri-calendar-2-line' },
  { slug: '2023', name: '2023', icon: 'ri-calendar-2-line' },
  { slug: '2022', name: '2022', icon: 'ri-calendar-2-line' },
  { slug: 'older', name: '更早', icon: 'ri-calendar-2-line' },
];

export const tvShows: TvShow[] = [
  {
    id: 1,
    title: '长安十二时辰',
    englishTitle: 'The Longest Day In Chang\'an',
    category: 'drama',
    genre: ['costume', 'suspense'],
    region: 'mainland',
    year: 2025,
    episodeCount: 48,
    currentEpisode: 48,
    status: '已完结',
    rating: 9.2,
    description: '唐朝天宝三年，上元节前夕，长安城陷入了一场惊天阴谋。死囚张小敬临危受命，与靖安司司丞李必携手，在十二个时辰之内揭穿敌人的阴谋，拯救长安城于危难之中。全剧以紧张刺激的节奏、精美的服化道和深刻的人物刻画，展现了大唐盛世的繁华与危机。',
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20drama%20poster%20with%20tang%20dynasty%20warrior%20in%20traditional%20armor%20holding%20sword%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20dark%20background%20with%20golden%20accents%2C%20epic%20historical%20atmosphere&width=600&height=800&seq=show-cover-01&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20tang%20dynasty%20cityscape%20at%20night%20with%20lanterns%20and%20palace%20architecture%2C%20dramatic%20cinematic%20wide%20shot%2C%20dark%20moody%20atmosphere%20with%20warm%20golden%20light%2C%20epic%20scale%2C%20movie%20poster%20style&width=1600&height=700&seq=show-banner-01&orientation=landscape',
    director: '曹盾',
    cast: ['雷佳音', '易烊千玺', '周一围', '芦芳生', '热依扎'],
    updateDay: '已完结',
    views: 9850000,
    isHot: true,
    isNew: false,
  },
  {
    id: 2,
    title: '星河长明',
    englishTitle: 'Stellar Long Night',
    category: 'drama',
    genre: ['romance', 'fantasy'],
    region: 'mainland',
    year: 2026,
    episodeCount: 40,
    currentEpisode: 28,
    status: '更新中',
    rating: 8.9,
    description: '在遥远的未来，人类已经进入星际文明时代。年轻的星舰指挥官林星河与神秘的外星少女明若相遇，两人在浩瀚宇宙中展开了一场跨越星系的浪漫冒险。该剧以宏大的太空场景和感人至深的情感线，打造了一部中国科幻爱情史诗。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20romance%20drama%20poster%20with%20couple%20in%20futuristic%20spacesuits%20against%20starry%20galaxy%20background%2C%20cinematic%20lighting%2C%20dreamy%20atmosphere%2C%20blue%20and%20purple%20nebula%20colors&width=600&height=800&seq=show-cover-02&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Futuristic%20spaceship%20interior%20with%20large%20window%20showing%20colorful%20nebula%20and%20distant%20planets%2C%20cinematic%20wide%20shot%2C%20sci-fi%20movie%20aesthetic%2C%20dramatic%20contrast%20lighting&width=1600&height=700&seq=show-banner-02&orientation=landscape',
    director: '杨磊',
    cast: ['张若昀', '李沁', '吴刚', '陈道明', '辛芷蕾'],
    updateDay: '每周一至周五更新',
    views: 12500000,
    isHot: true,
    isNew: true,
  },
  {
    id: 3,
    title: '繁花似锦',
    englishTitle: 'Blooming Splendor',
    category: 'drama',
    genre: ['urban', 'romance'],
    region: 'mainland',
    year: 2026,
    episodeCount: 36,
    currentEpisode: 36,
    status: '已完结',
    rating: 9.5,
    description: '讲述了一群年轻人在上海这座繁华都市中追逐梦想的故事。从陆家嘴的写字楼到新天地的咖啡馆，从外滩的江风到田子坊的小巷，他们经历了事业的起伏、爱情的甜蜜与苦涩，最终在这座城市中找到了属于自己的位置。',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20urban%20drama%20poster%20with%20stylish%20young%20professionals%20in%20Shanghai%20cityscape%2C%20fashionable%20clothing%2C%20warm%20golden%20evening%20light%2C%20cinematic%20portrait%20style&width=600&height=800&seq=show-cover-03&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Shanghai%20skyline%20at%20sunset%20with%20lujiazui%20skyscrapers%20and%20huangpu%20river%2C%20warm%20golden%20light%2C%20cinematic%20wide%20aerial%20view%2C%20modern%20city%20atmosphere&width=1600&height=700&seq=show-banner-03&orientation=landscape',
    director: '王家卫',
    cast: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾', '郑恺'],
    updateDay: '已完结',
    views: 18600000,
    isHot: true,
    isNew: false,
  },
  {
    id: 4,
    title: '逆天邪神',
    englishTitle: 'Against the Gods',
    category: 'anime',
    genre: ['fantasy', 'action'],
    region: 'mainland',
    year: 2026,
    episodeCount: 52,
    currentEpisode: 35,
    status: '更新中',
    rating: 8.7,
    description: '少年云澈身负血海深仇，意外获得逆天传承，从此踏上了一条逆天而行的修炼之路。在强者为尊的玄幻世界中，他以凡人之躯，逆天改命，一步步走向巅峰。精美绝伦的国漫画面，热血沸腾的战斗场面，打造年度最佳玄幻动画。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20donghua%20poster%20with%20young%20warrior%20holding%20glowing%20sword%2C%20fantasy%20martial%20arts%20theme%2C%20dramatic%20energy%20effects%2C%20dark%20background%20with%20flame%20elements&width=600&height=800&seq=show-cover-04&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20anime%20battle%20scene%20with%20floating%20mountains%20and%20ancient%20temples%2C%20martial%20arts%20energy%20effects%2C%20dramatic%20sky%2C%20donghua%20art%20style&width=1600&height=700&seq=show-banner-04&orientation=landscape',
    director: '张天晓',
    cast: ['阿杰', '季冠霖', '边江', '乔诗语'],
    updateDay: '每周六更新',
    views: 8200000,
    isHot: true,
    isNew: true,
  },
  {
    id: 5,
    title: '暗夜追凶',
    englishTitle: 'Night Pursuit',
    category: 'drama',
    genre: ['suspense', 'action'],
    region: 'mainland',
    year: 2025,
    episodeCount: 24,
    currentEpisode: 24,
    status: '已完结',
    rating: 9.0,
    description: '一桩十五年前的悬案，一名执着的老刑警，一个神秘的新搭档。当新的线索浮出水面，黑暗中的真相逐渐被揭开。每集一个案件，层层推进，反转不断，年度最佳悬疑剧，让观众欲罢不能。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20drama%20poster%20with%20detective%20in%20dark%20alley%20holding%20flashlight%2C%20noir%20atmosphere%2C%20rainy%20night%2C%20mysterious%20mood%2C%20cinematic%20style&width=600&height=800&seq=show-cover-05&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Dark%20rainy%20city%20alley%20at%20night%20with%20neon%20lights%20reflecting%20on%20wet%20pavement%2C%20noir%20cinematography%2C%20mysterious%20atmosphere%2C%20crime%20thriller%20aesthetic&width=1600&height=700&seq=show-banner-05&orientation=landscape',
    director: '五百',
    cast: ['潘粤明', '张译', '王泷正', '吕晓霖'],
    updateDay: '已完结',
    views: 11200000,
    isHot: false,
    isNew: false,
  },
  {
    id: 6,
    title: '舌尖上的江湖',
    englishTitle: 'Taste of Jianghu',
    category: 'variety',
    genre: ['comedy'],
    region: 'mainland',
    year: 2026,
    episodeCount: 12,
    currentEpisode: 8,
    status: '更新中',
    rating: 8.5,
    description: '一档融合美食与武侠文化的创新综艺。明星嘉宾们穿越到武侠世界，在各地寻找传说中的美食，同时完成各种趣味挑战。既有令人垂涎的美食画面，又有轻松搞笑的互动环节，是一档全家老少皆宜的下饭综艺。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20delicious%20traditional%20Chinese%20cuisine%20and%20ancient%20martial%20arts%20elements%2C%20warm%20colorful%20food%20photography%2C%20entertaining%20atmosphere&width=600&height=800&seq=show-cover-06&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20kitchen%20with%20steaming%20hot%20dishes%20and%20ancient%20decor%2C%20warm%20lighting%2C%20abundant%20food%20spread%20on%20wooden%20table%2C%20cinematic%20food%20photography&width=1600&height=700&seq=show-banner-06&orientation=landscape',
    director: '陈晓卿',
    cast: ['黄磊', '何炅', '张艺兴', '彭昱畅', '刘宪华'],
    updateDay: '每周日更新',
    views: 6500000,
    isHot: true,
    isNew: true,
  },
  {
    id: 7,
    title: '大明风华录',
    englishTitle: 'Ming Dynasty Chronicles',
    category: 'drama',
    genre: ['costume'],
    region: 'mainland',
    year: 2024,
    episodeCount: 60,
    currentEpisode: 60,
    status: '已完结',
    rating: 8.8,
    description: '以明朝永乐年间为背景，讲述了明成祖朱棣从靖难之役到开创永乐盛世的历史传奇。宏大的战争场面、精致的宫廷礼仪、复杂的人物关系，全景式展现了大明王朝最辉煌的时代。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20with%20ming%20dynasty%20emperor%20in%20golden%20dragon%20robe%2C%20imperial%20palace%20background%2C%20regal%20atmosphere%2C%20epic%20cinematic%20portrait&width=600&height=800&seq=show-cover-07&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20palace%20forbidden%20city%20at%20sunrise%2C%20grand%20ceremony%20scene%2C%20thousands%20of%20soldiers%20in%20formation%2C%20epic%20historical%20movie%20scale&width=1600&height=700&seq=show-banner-07&orientation=landscape',
    director: '张黎',
    cast: ['陈坤', '倪妮', '赵立新', '倪大红', '白宇'],
    updateDay: '已完结',
    views: 7800000,
    isHot: false,
    isNew: false,
  },
  {
    id: 8,
    title: '云端恋人',
    englishTitle: 'Cloud Lover',
    category: 'drama',
    genre: ['romance', 'urban'],
    region: 'korea',
    year: 2026,
    episodeCount: 16,
    currentEpisode: 10,
    status: '更新中',
    rating: 8.6,
    description: '一部讲述AI工程师与虚拟世界中AI角色之间跨次元爱情的韩剧。当代码与真心相遇，虚拟与现实的界限逐渐模糊。唯美的画面、细腻的情感、深刻的人机关系探讨，引发了观众对科技与爱情的全新思考。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romance%20drama%20poster%20with%20young%20couple%20in%20modern%20Seoul%20cityscape%2C%20soft%20pastel%20lighting%2C%20dreamy%20atmosphere%2C%20cherry%20blossom%20elements&width=600&height=800&seq=show-cover-08&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Modern%20Seoul%20city%20skyline%20at%20twilight%20with%20digital%20holographic%20elements%2C%20futuristic%20technology%20mixed%20with%20romantic%20atmosphere%2C%20cinematic%20wide%20shot&width=1600&height=700&seq=show-banner-08&orientation=landscape',
    director: '朴信宇',
    cast: ['李敏镐', '金智秀', '朴叙俊', '韩素希'],
    updateDay: '每周五、六更新',
    views: 9500000,
    isHot: true,
    isNew: true,
  },
  {
    id: 9,
    title: '时空侦探',
    englishTitle: 'Time Detective',
    category: 'drama',
    genre: ['suspense', 'fantasy'],
    region: 'japan',
    year: 2025,
    episodeCount: 10,
    currentEpisode: 10,
    status: '已完结',
    rating: 9.1,
    description: '一名能够穿越时间的侦探，利用超能力回到案发时刻寻找真相。但他渐渐发现，每一次穿越都在改变现实，引发蝴蝶效应。精妙的剧情设计，令人窒息的悬疑氛围，日剧年度口碑之作。',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20mystery%20drama%20poster%20with%20detective%20in%20trench%20coat%2C%20clock%20elements%2C%20dark%20noir%20atmosphere%2C%20Tokyo%20night%20street%20background&width=600&height=800&seq=show-cover-09&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Tokyo%20city%20at%20night%20with%20neon%20signs%20and%20rainy%20streets%2C%20clock%20tower%20in%20distance%2C%20mysterious%20noir%20atmosphere%2C%20cinematic%20composition&width=1600&height=700&seq=show-banner-09&orientation=landscape',
    director: '堤幸彦',
    cast: ['木村拓哉', '长泽雅美', '小栗旬', '石原里美'],
    updateDay: '已完结',
    views: 7200000,
    isHot: false,
    isNew: false,
  },
  {
    id: 10,
    title: '港岛风云',
    englishTitle: 'Storm Over Hong Kong',
    category: 'drama',
    genre: ['action', 'suspense'],
    region: 'hk-tw',
    year: 2025,
    episodeCount: 30,
    currentEpisode: 30,
    status: '已完结',
    rating: 8.4,
    description: '以香港回归后的金融界为舞台，讲述了一群年轻人在商海沉浮中坚守信念、对抗黑暗势力的故事。紧凑的剧情、实景拍摄的香港街景、实力派演员的精彩飙戏，再现经典港剧的魅力。',
    coverImage: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20drama%20poster%20with%20businessman%20in%20suit%20against%20victoria%20harbour%20skyline%2C%20dramatic%20lighting%2C%20modern%20financial%20district%20background&width=600&height=800&seq=show-cover-10&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20victoria%20harbour%20skyline%20at%20night%20with%20neon%20lights%20and%20skyscrapers%2C%20dramatic%20cinematic%20aerial%20view%2C%20modern%20Asian%20metropolis&width=1600&height=700&seq=show-banner-10&orientation=landscape',
    director: '庄文强',
    cast: ['古天乐', '刘青云', '张家辉', '吴镇宇'],
    updateDay: '已完结',
    views: 5800000,
    isHot: false,
    isNew: false,
  },
  {
    id: 11,
    title: '斗破苍穹之再起风云',
    englishTitle: 'Battle Through the Heavens: Rising Storm',
    category: 'anime',
    genre: ['fantasy', 'action'],
    region: 'mainland',
    year: 2026,
    episodeCount: 52,
    currentEpisode: 22,
    status: '更新中',
    rating: 8.3,
    description: '萧炎在迦南学院崭露头角后，踏上了前往中州的征途。更强大的敌人、更神秘的势力、更热血的对决。经典IP的全新动画演绎，战斗场面全面升级，画面质量达到国际一流水平。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20donghua%20poster%20with%20young%20male%20hero%20surrounded%20by%20colorful%20flames%2C%20fantasy%20martial%20arts%20theme%2C%20dynamic%20action%20pose%2C%20epic%20energy%20effects&width=600&height=800&seq=show-cover-11&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20landscape%20with%20floating%20islands%20and%20ancient%20Chinese%20temples%2C%20dramatic%20sky%20with%20fire%20and%20energy%20effects%2C%20donghua%20art%20style%20wide%20shot&width=1600&height=700&seq=show-banner-11&orientation=landscape',
    director: '赵霁',
    cast: ['张杰', '陈奕雯', '吴磊'],
    updateDay: '每周日更新',
    views: 10800000,
    isHot: true,
    isNew: true,
  },
  {
    id: 12,
    title: '欢笑一家人',
    englishTitle: 'Happy Family',
    category: 'variety',
    genre: ['comedy'],
    region: 'mainland',
    year: 2026,
    episodeCount: 24,
    currentEpisode: 15,
    status: '更新中',
    rating: 8.1,
    description: '一档以家庭为主题的喜剧综艺。邀请明星家庭参与各种趣味挑战和游戏，展现真实的家庭互动和温馨瞬间。笑点密集，温情满满，是周末放松的最佳选择。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20happy%20family%20group%20photo%2C%20colorful%20playful%20design%2C%20warm%20cheerful%20atmosphere%2C%20bright%20studio%20lighting&width=600&height=800&seq=show-cover-12&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Bright%20colorful%20TV%20studio%20set%20with%20game%20show%20elements%2C%20confetti%20and%20balloons%2C%20cheerful%20entertainment%20atmosphere%2C%20wide%20shot&width=1600&height=700&seq=show-banner-12&orientation=landscape',
    director: '严敏',
    cast: ['沈腾', '贾玲', '岳云鹏', '沙溢', '杨迪'],
    updateDay: '每周六更新',
    views: 7200000,
    isHot: true,
    isNew: false,
  },
  {
    id: 13,
    title: '西部往事',
    englishTitle: 'Once Upon a Time in the West',
    category: 'movie',
    genre: ['action'],
    region: 'western',
    year: 2025,
    episodeCount: 1,
    currentEpisode: 1,
    status: '已完结',
    rating: 8.9,
    description: '美国西部荒野，一个孤独的枪手来到小镇，卷入了当地农场主与铁路大亨之间的纷争。壮丽的西部风光、紧张的枪战场面、深刻的人性探讨，致敬经典西部片的诚意之作。',
    coverImage: 'https://readdy.ai/api/search-image?query=Western%20movie%20poster%20with%20cowboy%20silhouette%20against%20desert%20sunset%2C%20dramatic%20lighting%2C%20classic%20film%20poster%20style%2C%20warm%20earthy%20tones&width=600&height=800&seq=show-cover-13&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Sweeping%20American%20western%20desert%20landscape%20at%20sunset%2C%20dramatic%20clouds%2C%20lone%20rider%20on%20horseback%2C%20cinematic%20wide%20shot%2C%20epic%20scale&width=1600&height=700&seq=show-banner-13&orientation=landscape',
    director: '泰勒·谢里丹',
    cast: ['克里斯·帕拉特', '维奥拉·戴维斯', '杰森·莫玛'],
    updateDay: '已完结',
    views: 4500000,
    isHot: false,
    isNew: false,
  },
  {
    id: 14,
    title: '深海迷踪',
    englishTitle: 'Deep Sea Mystery',
    category: 'movie',
    genre: ['suspense', 'action'],
    region: 'western',
    year: 2026,
    episodeCount: 1,
    currentEpisode: 1,
    status: '已完结',
    rating: 8.7,
    description: '一艘深海探测器在马里亚纳海沟失联，一支精英救援队潜入万米深海，却发现了一个惊天秘密。极致的深海视觉效果，令人窒息的紧张氛围，好莱坞年度科幻惊悚巨制。',
    coverImage: 'https://readdy.ai/api/search-image?query=Hollywood%20sci-fi%20thriller%20poster%20with%20deep%20sea%20submersible%20and%20mysterious%20glowing%20creature%2C%20dark%20ocean%20depths%2C%20suspenseful%20atmosphere%2C%20cinematic%20style&width=600&height=800&seq=show-cover-14&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Deep%20ocean%20abyss%20with%20bioluminescent%20creatures%20and%20underwater%20research%20station%2C%20dark%20blue%20depths%2C%20mysterious%20atmosphere%2C%20cinematic%20wide%20shot&width=1600&height=700&seq=show-banner-14&orientation=landscape',
    director: '詹姆斯·卡梅隆',
    cast: ['汤姆·克鲁斯', '赞达亚', '迈克尔·B·乔丹'],
    updateDay: '已完结',
    views: 8900000,
    isHot: true,
    isNew: true,
  },
  {
    id: 15,
    title: '宫心计2：深宫怨',
    englishTitle: 'Palace Scheme 2: Deep Palace',
    category: 'drama',
    genre: ['costume'],
    region: 'hk-tw',
    year: 2026,
    episodeCount: 42,
    currentEpisode: 30,
    status: '更新中',
    rating: 8.6,
    description: '清朝后宫，妃嫔争宠，权谋暗涌。新入宫的秀女如何在尔虞我诈中生存？延续第一部的精良制作，更复杂的宫斗格局，更精美的服化道，TVB年度古装巨制。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20palace%20drama%20poster%20with%20qing%20dynasty%20imperial%20concubine%20in%20elaborate%20silk%20costume%2C%20golden%20palace%20interior%2C%20dramatic%20lighting%2C%20regal%20atmosphere&width=600&height=800&seq=show-cover-15&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20interior%20with%20golden%20decorations%20and%20red%20lanterns%2C%20imperial%20court%20scene%2C%20dramatic%20lighting%2C%20historical%20drama%20aesthetic&width=1600&height=700&seq=show-banner-15&orientation=landscape',
    director: '戚其义',
    cast: ['佘诗曼', '陈豪', '杨怡', '黎姿', '林保怡'],
    updateDay: '每周一至周五更新',
    views: 7800000,
    isHot: true,
    isNew: true,
  },
  {
    id: 16,
    title: '笑傲江湖之东方不败',
    englishTitle: 'Swordsman: Invincible East',
    category: 'movie',
    genre: ['action', 'costume'],
    region: 'mainland',
    year: 2025,
    episodeCount: 1,
    currentEpisode: 1,
    status: '已完结',
    rating: 8.3,
    description: '金庸经典武侠的全新电影改编。以东方不败的视角重新诠释笑傲江湖的故事，既有快意恩仇的江湖豪情，又有令人心碎的情感纠葛。顶级武术指导打造的精彩打斗场面，每一帧都是视觉盛宴。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20movie%20poster%20with%20warrior%20in%20red%20flowing%20robes%20flying%20through%20bamboo%20forest%2C%20dramatic%20action%20pose%2C%20wuxia%20cinematic%20style&width=600&height=800&seq=show-cover-16&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Misty%20Chinese%20bamboo%20forest%20at%20sunrise%20with%20martial%20arts%20warriors%20in%20epic%20battle%2C%20wuxia%20film%20aesthetic%2C%20cinematic%20wide%20shot&width=1600&height=700&seq=show-banner-16&orientation=landscape',
    director: '徐克',
    cast: ['张震', '周迅', '陈坤', '章子怡'],
    updateDay: '已完结',
    views: 6700000,
    isHot: false,
    isNew: false,
  },
];

export const articles: TvArticle[] = [
  {
    id: 1,
    title: '2026年最值得期待的十部国产剧，每一部都是爆款预定',
    category: '资讯',
    summary: '2026年国产剧市场精彩纷呈，从古装巨制到现代都市，从悬疑推理到科幻爱情，各路大制作蓄势待发。本文为你盘点今年最值得关注的十部国产剧。',
    content: `2026年，国产剧市场迎来了前所未有的繁荣。各大平台纷纷推出重磅作品，从制作规模到演员阵容都达到了新的高度。

首先，不得不提的是《星河长明》。这部科幻爱情剧集结了张若昀、李沁等实力派演员，以宏大的太空场景和细腻的情感线吸引了无数观众的目光。开播以来，热度持续走高，豆瓣评分稳定在8.9分。

紧随其后的是《繁花似锦》。王家卫导演的首部电视剧作品，以上海为背景，讲述了一群年轻人在都市中的奋斗与爱情。胡歌、马伊琍的演技碰撞，加上王家卫独特的视觉美学，让这部剧成为年度最受关注的作品之一。

古装剧方面，《长安十二时辰》以精良的制作和紧凑的剧情获得了观众的广泛好评。而《宫心计2：深宫怨》则延续了第一部的高水准，在宫斗剧式微的当下依然表现抢眼。

动漫领域，《逆天邪神》和《斗破苍穹之再起风云》代表了国产动画的最高水准。精美的画面、热血的剧情，让这两部作品成为了年轻观众的最爱。

悬疑剧方面，《暗夜追凶》以扎实的剧本和出色的表演成为了年度口碑之作。潘粤明和张译的强强联手，为观众奉献了一场精彩的演技盛宴。

2026年的国产剧市场，正在以更高的品质和更丰富的类型，满足着观众日益增长的观剧需求。`,
    author: '影视观察员',
    publishDate: '2026-07-28',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20TV%20drama%20production%20set%20with%20cameras%20and%20lighting%20equipment%2C%20professional%20film%20crew%20working%2C%20behind%20the%20scenes%20atmosphere%2C%20cinematic%20photography&width=800&height=500&seq=article-cover-01&orientation=landscape',
    views: 156000,
    tags: ['国产剧', '2026', '推荐', '热播剧'],
  },
  {
    id: 2,
    title: '从《繁花似锦》看上海都市剧的审美变迁',
    category: '影评',
    summary: '王家卫的《繁花似锦》不仅是一部都市情感剧，更是一部关于上海的城市影像志。本文从视觉美学角度解析这部剧的独特魅力。',
    content: `《繁花似锦》的播出，在国产都市剧领域投下了一枚重磅炸弹。王家卫用他标志性的视觉语言，重新定义了都市剧的审美标准。

在这部剧中，上海不再仅仅是一个背景板，而是一个有温度、有情感的角色。从外滩的晨光到陆家嘴的夜色，从弄堂里的烟火气到新天地的时尚感，每一个场景都经过精心构图，每一帧画面都可以截下来当壁纸。

胡歌饰演的角色穿梭在上海的大街小巷，镜头跟随着他的脚步，展现了一个既熟悉又陌生的上海。这种陌生感来自王家卫独特的色彩运用——暖黄色的灯光、青灰色的天空、深红色的旗袍，这些色彩组合在一起，营造出一种既复古又现代的氛围。

与以往的都市剧相比，《繁花似锦》在叙事节奏上也做出了大胆的突破。王家卫没有采用传统的线性叙事，而是通过闪回、平行蒙太奇等手法，将过去与现在交织在一起，让观众在时间的碎片中拼凑出完整的故事。

这种叙事方式可能会让一些观众感到困惑，但正是这种"不友好"的叙事，让《繁花似锦》区别于那些流水线生产的都市剧，成为了一部真正具有艺术价值的作品。`,
    author: '深度影评人',
    publishDate: '2026-07-25',
    coverImage: 'https://readdy.ai/api/search-image?query=Shanghai%20cityscape%20at%20sunset%20with%20artistic%20cinematic%20color%20grading%2C%20warm%20golden%20light%2C%20film%20aesthetic%2C%20nostalgic%20urban%20atmosphere&width=800&height=500&seq=article-cover-02&orientation=landscape',
    views: 98000,
    tags: ['繁花似锦', '王家卫', '都市剧', '审美'],
  },
  {
    id: 3,
    title: '国漫崛起：《逆天邪神》如何重新定义国产动画',
    category: '资讯',
    summary: '《逆天邪神》以其精湛的制作水准和引人入胜的剧情，成为了国产动画的新标杆。本文深度解析这部现象级作品的成功之道。',
    content: `当《逆天邪神》的第一集在各大平台上线时，没有人预料到它会引发如此巨大的反响。短短几个月内，播放量突破8亿，豆瓣评分稳定在8.7分，弹幕总数超过3000万条。

这部动画的成功，首先得益于其精良的制作。制作团队采用了最新的3D渲染技术，结合中国传统水墨画的审美，创造出了独特的"国风科幻"视觉风格。战斗场面的流畅度和特效的精细程度，已经达到了国际一流水准。

但仅有好看的画面是不够的。《逆天邪神》在剧情改编上也下足了功夫。相比原著小说，动画版对人物性格进行了更加立体的塑造，对情感线进行了更加细腻的刻画。主角云澈的成长轨迹清晰可见，从一个懵懂少年到成熟强者的转变，让观众产生了强烈的代入感。

配音阵容同样功不可没。阿杰、季冠霖等国内顶级声优的加盟，为角色注入了灵魂。每一句台词都经过了精心打磨，既有古风的韵味，又不失现代的感染力。

《逆天邪神》的成功，证明了国产动画完全有能力与国际顶尖作品一较高下。它为整个行业树立了一个标杆：只有尊重观众、尊重作品，才能创造出真正打动人心的作品。`,
    author: '动漫评论家',
    publishDate: '2026-07-20',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20studio%20with%20artists%20working%20on%20digital%20tablets%2C%20donghua%20production%20environment%2C%20creative%20workspace%2C%20colorful%20character%20designs%20on%20screens&width=800&height=500&seq=article-cover-03&orientation=landscape',
    views: 132000,
    tags: ['国漫', '逆天邪神', '动画', '制作'],
  },
  {
    id: 4,
    title: '51影视观剧指南：暑期档必看片单',
    category: '推荐',
    summary: '暑假来临，51影视为你精心整理了暑期档最值得观看的影视作品清单，涵盖各种类型，总有一部适合你。',
    content: `暑假是追剧的最佳时机。51影视为你准备了这份暑期档观剧指南，让你不错过任何一部好剧。

悬疑爱好者首选：《暗夜追凶》——24集紧凑剧情，每集一个案件，层层推进，反转不断。潘粤明和张译的演技对决堪称教科书级别。

古装剧迷必看：《长安十二时辰》——48集的史诗巨制，服化道精良，剧情紧凑。雷佳音和易烊千玺的组合带来了意想不到的化学反应。

科幻爱情：《星河长明》——国产科幻剧的新标杆。张若昀和李沁的星际之恋，视觉震撼，情感动人。

国漫爱好者：《逆天邪神》和《斗破苍穹之再起风云》——两部顶级国漫同期热播，热血战斗与东方美学的完美结合。

综艺放松：《舌尖上的江湖》——美食加武侠的创新组合，轻松搞笑，是下饭的最佳选择。

这个暑假，51影视陪你一起追剧！`,
    author: '51影视编辑部',
    publishDate: '2026-07-15',
    coverImage: 'https://readdy.ai/api/search-image?query=Cozy%20home%20living%20room%20with%20large%20TV%20screen%20showing%20movie%2C%20popcorn%20and%20drinks%20on%20coffee%20table%2C%20warm%20evening%20atmosphere%2C%20comfortable%20sofa&width=800&height=500&seq=article-cover-04&orientation=landscape',
    views: 210000,
    tags: ['暑期档', '观剧指南', '推荐', '片单'],
  },
];